import styled from "@emotion/styled"
import { SearchIcon } from "@ninjaone/icons"
import { sizer } from "@ninjaone/utils"
import { StyledInput } from "./Input"

const StyledSearchBar = styled.div`
  position: relative;
  height: ${sizer(10)};
  width: ${({ width }) => width ?? sizer(150)};
  > * {
    width: inherit;
  }
  & input {
    height: 100%;
  }
`
const StyledPlaceholder = styled.span`
  height: inherit;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  padding-right: ${sizer(3)};
  pointer-events: none;
`

export default function SearchBar({ placeholderText, width, ...rest }) {
  return (
    <StyledSearchBar {...{ width }}>
      <StyledInput type="search" hasIcon placeholder={placeholderText} {...rest} />
      <StyledPlaceholder>
        <SearchIcon color="gray" />
      </StyledPlaceholder>
    </StyledSearchBar>
  )
}
